import * as React from 'react';
import styled from 'styled-components/macro';
// import Platform from '../../platform';

export const StyledWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export default function ScrollTopHack(WrappedComponent, style = {}) {
  class SetScrollTopHOCContainer extends React.Component {
    ref = React.createRef();

    componentDidMount() {
      this.ref.current && this.ref.current.addEventListener('scroll', this.setScrollTop);
    }

    componentWillUnmount() {
      this.ref.current && this.ref.current.removeEventListener('scroll', this.setScrollTop);
      this.ref = { current: null };
    }

    setScrollTop = e => {
      const { current } = this.ref;
      if (current && current.scrollTop) {
        // && !Platform.supportsPreventScroll
        current.scrollTop = 0;
      }
      if (current && current.scrollLeft) {
        // && !Platform.supportsPreventScroll
        current.scrollLeft = 0;
      }
    };

    render() {
      return (
        <StyledWrapper ref={this.ref} style={style}>
          <WrappedComponent {...this.props} />
        </StyledWrapper>
      );
    }
  }

  return SetScrollTopHOCContainer;
}
